export default __webpack_public_path__ + "static/media/boomi3.aafe561a.svg";